import { NavLink } from "react-router-dom"
import { motion } from "framer-motion"
//import { HOME_ANIMATION } from "@/app/pages/homePage/utils/home.constants"
import TitleBoldM from "../text/text-bold-m"
import { LIBRARYTABS } from "@/constants"

const pageVariants = {
  initial: {
    opacity: 0,
    x: 5,
  },

  animate: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
    },
  },

  exit: {
    opacity: 0,
    x: -5,
    transition: {
      duration: 0.3,
    },
  },
}

type TabItem = {
  title: string
  path: string
}

function LibraryTabBtn() {
  return (
    <motion.nav 
      variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
      className="relative w-[70vw] landscape:w-115">
      <div
        className="
          relative
          max-w-120
          overflow-hidden

          rounded-[2rem]

          border border-white/[0.28]

          bg-black/[0.35]

          backdrop-blur-[3rem]
          backdrop-saturate-[180%]
          backdrop-contrast-[1.5]

          shadow-[0_20px_60px_rgba(0,0,0,0.45)]
        "
      >
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "radial-gradient(circle at 50% 0%, rgba(255,255,255,0.12), transparent 70%)",
          }}
        />

        <div
          className="
            absolute
            left-0
            top-0
            bottom-0
            z-20
            w-10
            pointer-events-none
          "
          style={{
            background:
              "linear-gradient(to right, bg-[var(--soft-bg)] , transparent)",
          }}
        />

        <div
          className="
            absolute
            right-0
            top-0
            bottom-0
            z-20
            w-10
            pointer-events-none
          "
          style={{
            background:
              "linear-gradient(to left, bg-[var(--soft-bg)], transparent)",
          }}
        />

        <div
          className="
            flex
            gap-1 landscape:gap-1.5
            overflow-x-auto
            no-scrollbar
            px-1
            py-1
            whitespace-nowrap
            scroll-smooth
          "
        >
          {LIBRARYTABS.map((item: TabItem) => (
            <NavLink
              key={item.title}
              to={item.path}
              end
            >
              {({ isActive }) => (
                <motion.div
                  whileTap={{ scale: 0.95 }}
                  whileHover={{ scale: 1.03 }}
                  className="
                    relative
                    flex-none
                    h-8
                    px-2 landscape:px-3

                    flex
                    items-center
                    justify-center

                    rounded-[18px]

                    whitespace-nowrap

                    transition-all
                  "
                  style={{
                    background: isActive
                      ? "rgba(255,255,255,0.35)"
                      : "rgba(255,255,255,0.2)",

                    border: isActive
                      ? "1px solid rgba(255,255,255,0.15)"
                      : "1px solid rgba(255,255,255,0.1)",

                    boxShadow: isActive
                      ? `
                        inset 0 1px 0 rgba(255,255,255,0.15),
                        0 0 25px rgba(255,255,255,0.08)
                      `
                      : `
                        inset 0 1px 0 rgba(255,255,255,0.04)
                      `,
                  }}
                >
                  {isActive && (
                    <>
                      <motion.div
                        layoutId="library-active-tab"
                        className="
                          absolute
                          inset-0
                          rounded-[18px]
                        "
                      />

                      <div
                        className="
                          absolute
                          top-1
                          left-1/2
                          h-4
                          w-full
                          -translate-x-1/2
                          rounded-full
                        "
                        style={{
                          background:
                            "radial-gradient(circle, rgba(255,255,255,0.2), transparent)",
                          filter: "blur(5px)",
                        }}
                      />
                    </>
                  )}

                  <div
                    className={`
                      relative
                      z-10
                      ${
                        isActive
                          ? "text-[var(--primary-color)]"
                          : "opacity-60 text-[var(--primary-color)]"
                      }
                    `}
                  >
                    <TitleBoldM>
                      {item.title}
                    </TitleBoldM>
                  </div>
                </motion.div>
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </motion.nav>
  )
}

export default LibraryTabBtn